import DataSummaryFactory from './DataSummaryFactory';
export default DataSummaryFactory;
//# sourceMappingURL=index.js.map